import type { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { toast } from '@hivebrite/design-system/Toast';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Forum/constants';
import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { getEditDiscussion } from 'hb-react/frontoffice/apps/Forum/requests';
import type { Discussion } from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

export const useGetEditDiscussion = (discussionId: number) => {
  const navigate = useNavigate();
  const { topicId } = useTopicContext();
  const { configUrls } = useForumContext();
  const {
    data: discussion,
    isLoading,
    isError,
    error,
  } = useQuery<Discussion, AxiosError>(
    [QUERY_KEYS.editDiscussion, discussionId, topicId],
    () => getEditDiscussion({ discussionId, configUrls }),
    {
      onError: (error) => {
        if (error?.request?.status === 401) {
          navigate('..');
          toast.error(__('You are not authorized to access this page'));
        }
      },
    },
  );

  return { discussion, isLoading, isError, error };
};
